import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { LocationInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { LocationDetailSaveModel } from '../../location-details/models/location-detail-save.model';
import { SaveLocation, SaveLocationVariables } from '../../location-details/queries/generated/SaveLocation';
import { SaveLocationMutation } from '../../location-details/queries/save-location.graphql';

@Injectable({ providedIn: 'root' })
export class AddLocationApiService {
   constructor(private apiService: LcsApiService) {}

   create(locationDetail: LocationDetailSaveModel): Observable<ExecutionResult<SaveLocation>> {
      const fields: (keyof LocationInput)[] = [
         'accountId',
         'name',
         'houseNumber',
         'directionalPrefix',
         'streetName',
         'streetNameSuffix',
         'directionalPostfix',
         'city',
         'state',
         'postalCode',
         'country',
         'timeZoneId',
         'comment',
      ];
      return this.apiService.query<SaveLocation, SaveLocationVariables>({
         query: SaveLocationMutation,
         variables: {
            location: {
               ...locationDetail,
               fields: fields,
            },
         },
      });
   }
}
